<script setup lang="ts">
import { computed, onMounted, onUnmounted } from 'vue';

import { isMobile } from '~/utils/isMobile';

const isOpen = defineModel<boolean>({
    default: false,
});

const burgerClasses = computed(() => ({
    'burger--is-opened': isOpen.value,
}));

const toggleMenu = () => {
    isOpen.value = !isOpen.value;
};

const handleResize = () => {
    if (!isMobile()) {
        isOpen.value = false;
    }
};

onMounted(() => {
    window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
});
</script>

<template>
    <button
        type="button"
        class="burger mobile-only"
        :aria-label="isOpen ? 'Закрыть меню' : 'Открыть меню'"
        :aria-expanded="isOpen"
        :class="burgerClasses"
        @click="toggleMenu"
    >
        <span
            v-for="item in 3"
            :key="item"
            class="burger__item"
        />
    </button>
</template>

<style scoped lang="scss">
@import 'styles/burger';
</style>
